function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoFerinaCura = function SvgLogoFerinaCura(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 229.939,
    height: 331.578,
    viewBox: "0 0 60.838 87.73"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M96.528 232.44c.548-2.346.636-7.266.175-9.804-.285-1.573-.293-1.58-.333-.302-.034 1.117-.747 2.005-.747.932 0-.209-.934-1.796-2.075-3.529-4.102-6.226-5.303-12-3.486-16.762 2.097-5.496 7.682-11.338 7.682-8.036 0 4.62 3.716 7.68 13.08 10.768 20.233 6.674 22.825 19.67 4.772 23.936-3.96.936-11.54 2.469-12.206 2.469-1.173 0 .826-7.463 2.565-9.574.411-.499.66-1.007.552-1.13-.759-.865-4.432 6.347-4.83 9.483-.24 1.91-1.125 2.576-4.526 3.414-1.123.277-1.123.277-.623-1.865",
    style: {
      fill: "#ae744c",
      fillOpacity: 1,
      strokeWidth: 0.999998
    },
    transform: "translate(-77.594 -166.501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.845 239.467c0-.22.416-1.248.924-2.285 2.808-5.73 1.33-12.859-4.894-23.623-6.59-11.394-7.213-18.281-2.535-28.014 1.065-2.215 2.42-5.637 3.013-7.605 1.616-5.371 3.654-8.64 6.674-10.704 1.674-1.145 1.654-1.16 1.923 1.47.38 3.706 1.612 6.92 1.612 4.202 0-.82.897-1.85 2.999-3.44 2.356-1.783 2.555-1.59 2.375 2.322-.156 3.388-.156 3.388 1.676 5.35 1.008 1.08 2.26 2.867 2.783 3.972.76 1.61 1.353 2.249 2.98 3.218 2.386 1.42 2.47 1.798.737 3.306-1.418 1.234-1.922 1.273-11.429.88-13.47-.558-19.41 19.147-8.738 28.987 5.869 5.411 6.873 6.912 7.225 10.803.35 3.868-.966 7.138-3.596 8.94a194 194 0 0 0-2.933 2.042c-.438.318-.796.398-.796.179",
    style: {
      fill: "#ae744c",
      fillOpacity: 1,
      strokeWidth: 0.999998
    },
    transform: "translate(-77.594 -166.501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.594 249.205c0-.151 1.392-1.089 3.093-2.084s3.475-2.11 3.94-2.476c3.876-3.052 5.376-4.029 8.893-5.794 4.661-2.338 6.026-2.75 13.748-4.152 12.64-2.295 17.63-4.648 21.184-9.99 1.974-2.969 2.879-7.862 1.826-9.881-.837-1.607.475-.752 3.069 1.998 12.76 13.53-.11 31.119-20.688 28.274-2.039-.282-2.512-1.089-.639-1.089.708 0 2.57-.364 4.136-.808 10.294-2.921 17.217-10.907 17.052-19.67-.045-2.417-.045-2.417-.298.044-1.355 13.21-10.957 19.608-30.169 20.101-10.538.271-11.319.402-17.493 2.939-4.375 1.797-7.654 2.906-7.654 2.588",
    style: {
      fill: "#6f918a",
      fillOpacity: 1,
      strokeWidth: 0.999996
    },
    transform: "translate(-77.594 -166.501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.74 253.989c-1.185-.17-3.449-.622-5.029-1.004-2.526-.61-4.232-1.167-10.333-3.376-1.726-.624-3.673.126-2.183-.604 7.775-3.807 16.56-5.105 30.767-2.395 8.462 1.615 16.807-.52 22.048-5.642 2.293-2.24 2.655-2.196 1.124.138-2.993 4.563-10.922 10.173-16.22 11.474-.688.17-2.157.57-3.264.891-2.363.685-13.392 1.022-16.91.518",
    style: {
      fill: "#4b627a",
      fillOpacity: 1,
      strokeWidth: 0.999996
    },
    transform: "translate(-77.594 -166.501)"
  }));
};
export default SvgLogoFerinaCura;